import store from '@/services/store.js';
import { EventBus } from '@/services/Event.js';
import UpgradeMembership from '@/components/user/dashboard/pages/membership/upgrade-membership/upgrade-membership.vue';

export default {
    name: 'JuniorUpgradeMembership',
    components: {
        UpgradeMembership
    },
    data() {
        return {
            isProcessing: true,
            juniors: [],
            juniorName: '',
            juniorId: -3
        }
    },
    computed: {
        loadedUserName() {
            var self = this;
            if (self.juniorName) {
                var id = self.getJuniorIdByName();

                if (id !== self.juniorId) {
                    self.changeJunior(id);
                    self.$console("Loaded upgrade membership data for junior - " + id + " - " + self.juniorName);
                }

                return self.user;
            }
            return '';
        },
    },
    methods: {
        getJuniorIdByName() {
            var self = this;
            var juniorArray = self.juniors.filter(junior => {
                return junior.fullName === self.juniorName;
            });
            if (juniorArray.length) {
                return juniorArray[0].id;
            }
            else {
                return self.juniors[0].id;
            }
        },
        changeJunior(id) {
            this.juniorId = id;
            store.commit('setCurrentJunior', this.juniorName);
            EventBus.$emit("user-load-upgrade-membership", this.juniorId);
        },
        getData() {
            var self = this;
            self.checkStatus();

            var preloadedUser = store.getters.getUserShortInfo;
            if (preloadedUser && preloadedUser.isSuccess) {
                if (preloadedUser.details.juniors && preloadedUser.details.juniors.length > 0) {
                    self.juniors = preloadedUser.details.juniors;
                    self.juniorId = self.getJuniorIdByName();

                    self.$console();
                    self.$console("Loaded juniors:");
                    self.$console({ Juniors: self.juniors });
                    self.$console();
                    self.$console("Loaded data for junior - " + self.juniorId + " - " + self.juniorName);
                }
                else {
                    window.history.back();
                }
                self.isProcessing = false;
            }
            
        },
        checkStatus() {
            var self = this;
            var currentJun = store.getters.getCurrentJunior;
            if (currentJun) {
                if (currentJun == 'new') {
                    setTimeout(function () {
                        if (!self.juniors || !self.juniors.length) {
                            setTimeout(function () { self.checkStatus() }, 0);
                        }
                        else {
                            var jun = self.juniors[self.juniors.length - 1];
                            self.juniorName = jun.fullName;
                            store.commit('setCurrentJunior', self.juniorName);
                        }
                    }, 0);
                }
                else {
                    self.juniorName = currentJun;
                }
            }
        }
    },
    mounted() {
        var self = this;
        self.getData();
        EventBus.$off("user-load-junior-upgrade-membership");
        EventBus.$on("user-load-junior-upgrade-membership", () => { self.getData(); });
    }
}



// WEBPACK FOOTER //
// ./src/components/user/dashboard/pages/junior/junior-upgrade-membership/junior-upgrade-membership.js